import { ChangeDetectionStrategy, Component, inject, input, linkedSignal, output } from '@angular/core';
import { QueryBarItemComponent } from '../../query-bar/query-bar-item/query-bar-item.component';
import { DateService } from '@softline/core';
import { FormatPipe, selectDateFn } from '@softline/ui-core';


@Component({
  selector: 'soft-date-filter',
  imports: [
    QueryBarItemComponent,
    FormatPipe
  ],
  templateUrl: './date-filter.component.html',
  styleUrl: './date-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateFilterComponent {

  dateService = inject(DateService);
  selectDate = selectDateFn();

  valueInput = input<string>(this.dateService.now(), {alias: 'value'});
  title = input.required<string>();
  valueChange = output<string>();

  value = linkedSignal(() => this.valueInput());

  async onClick(): Promise<void> {
    const result = await this.selectDate({value: this.value()});
    if(!result || result === 'DISMISSED')
      return;
    this.value.set(result);
    this.valueChange.emit(result);
  }
}
